import axios from "axios";

// class ScheduleService {
//   async getScheduleOpen() {
//     return await axios.get("schedule/open");
//   }

//   async cretate(value: any) {
//     console.log(value);
//   }
// }
// export default new ScheduleService();

const getScheduleOpen = async () => {
  return await axios.get("schedule/open");
};
const getScheduleClose = async () => {
  return await axios.get("schedule/close");
};

const newSchedule = async (values: any) => {
  return await axios.post("schedule", values);
};

const getScheduleOpenForSend = async (type: string) => {
  // console.log(`schedule/${type}`);

  return await axios.get(`schedule/${type}`);
};

const getAll = async () => {
  return await axios.get("schedule");
};

const udpateStatus = async (id: number) => {
  return await axios.put(`schedule/status/${id}`);
};

const getById = async (id: number) => {
  return await axios.get(`schedule/${id}`);
};

const getType = async (id: number, lang: string = "") => {
  return await axios.get(`schedule/${id}`).then((res) => {
    if (lang === "TH") {
      return res.data.type === "tqf" ? "มคอ." : "อชว.";
    } else {
      return res.data.type;
    }
  });
};

const updateSchedule = async (id: number, values: any) => {
  return await axios.put(`schedule/${id}`, values);
};
const deleteSchedule = async (id: number) => {
  return await axios.delete(`schedule/${id}`);
};

const ScheduleService = {
  getScheduleOpen,
  getScheduleClose,
  newSchedule,
  getScheduleOpenForSend,
  getAll,
  udpateStatus,
  getById,
  getType,
  updateSchedule,
  deleteSchedule,
};

export default ScheduleService;
